import { appConst } from "../../../AppConst";
import { MCard } from "../../../components/mobile";

interface IContactItemProps {
    /** Class icon Font Awesome. */
    icon: string;
    label: string;
    value: string;
    /** Có href → cả dòng bấm được (tel:/mailto:/http). Không có → chỉ hiển thị. */
    href?: string;
}

/** 1 dòng liên hệ — bấm cả dòng để gọi / gửi mail. Touch target ≥ 56px. */
const ContactItem = ({ icon, label, value, href }: IContactItemProps) => {
    const inner = (
        <>
            <span className="m-contact-ic">
                <i className={icon} />
            </span>
            <span className="m-contact-main">
                <span className="m-contact-label">{label}</span>
                <span className="m-contact-value">{value}</span>
            </span>
            {href && <i className="fas fa-chevron-right m-contact-go" />}
        </>
    );
    if (!href) {
        return <div className="m-contact-item">{inner}</div>;
    }
    const isExternal = href.startsWith("http");
    return (
        <a
            className="m-contact-item"
            href={href}
            target={isExternal ? "_blank" : undefined}
            rel={isExternal ? "noreferrer" : undefined}
        >
            {inner}
        </a>
    );
};

/**
 * Tab "Hỗ trợ" — thay cho footer ở bản mobile. Gom thông tin liên hệ trường + đầu mối
 * hỗ trợ đăng ký học phần / kỹ thuật. SĐT, email bấm gọi trực tiếp được.
 */
const SupportTab = () => {
    const { logoUrl, webName, copyright } = appConst.branding;
    const { address, email, hotline, website } = appConst.contact;
    const { daoTao, tech } = appConst.support;

    const telHref = (phone: string) => `tel:${phone.replace(/\./g, "")}`;

    return (
        <>
            <div className="m-section-title">Thông tin liên hệ</div>
            <MCard>
                <div className="m-contact-brand">
                    {logoUrl && <img src={logoUrl} alt={webName} />}
                    <span className="m-contact-brand-name">{webName}</span>
                </div>
                {address && (
                    <ContactItem icon="fas fa-location-dot" label="Địa chỉ" value={address} />
                )}
                {hotline && (
                    <ContactItem
                        icon="fas fa-phone"
                        label="Điện thoại"
                        value={hotline}
                        href={telHref(hotline)}
                    />
                )}
                {email && (
                    <ContactItem
                        icon="fas fa-envelope"
                        label="Email"
                        value={email}
                        href={`mailto:${email}`}
                    />
                )}
                {website && (
                    <ContactItem icon="fas fa-globe" label="Website" value={website} href={website} />
                )}
            </MCard>

            <div className="m-section-title">Cần hỗ trợ?</div>
            <MCard>
                {daoTao && (daoTao.email || daoTao.phone) && (
                    <>
                        <div className="m-support-sub">Vướng mắc đăng ký học phần</div>
                        {daoTao.phone && (
                            <ContactItem
                                icon="fas fa-phone"
                                label={daoTao.name}
                                value={daoTao.phone}
                                href={telHref(daoTao.phone)}
                            />
                        )}
                        {daoTao.email && (
                            <ContactItem
                                icon="fas fa-envelope"
                                label={daoTao.name}
                                value={daoTao.email}
                                href={`mailto:${daoTao.email}`}
                            />
                        )}
                    </>
                )}
                {tech.length > 0 && (
                    <>
                        <div className="m-support-sub">Hỗ trợ kỹ thuật</div>
                        {tech.map(t =>
                            t.phone ? (
                                <ContactItem
                                    key={t.name}
                                    icon="fas fa-headset"
                                    label={t.name}
                                    value={t.phone}
                                    href={telHref(t.phone)}
                                />
                            ) : null
                        )}
                    </>
                )}
            </MCard>

            <div className="m-copyright">{copyright}</div>
        </>
    );
};

export default SupportTab;
